module.exports = __webpack_public_path__ + "static/media/1274_CareTeam11_photo.782df60a.png";